import { useClientTranslations } from "../lib/i18n/client";
import {
	deriveJourneyChatContext,
	type JourneyChatContext,
} from "../lib/journey/journeyChatContext";
import { resolveTreatmentType } from "../types/journey";
import { useJourneyProgress } from "./useJourneyProgress";
import type { User } from "./useUser";

// Builds the journey context sent in the /api/chat body so Eve can ground
// answers in the user's actual stage (handoff onboarding-v5-eve-journey-step-context).
// Returns null when there is no resolvable active journey/step → caller omits it.
export function useJourneyChatContext(
	user: User | undefined,
): JourneyChatContext | null {
	const { locale } = useClientTranslations("journey");
	const treatmentType = resolveTreatmentType(user?.details);
	const { journey, stepStates } = useJourneyProgress(treatmentType, { locale });
	return deriveJourneyChatContext(journey, stepStates);
}
